import React from 'react'
import { useSelector } from 'react-redux'

import { useOfMinWidth } from 'hooks'
import { APP_BREAKPOINTS } from 'consts'
import { userDataSelector } from 'containers/UserInfo/selectors'
import { useGetCartQuery } from 'containers/Cart/rtkApi'
import SummaryInfoBox from 'views/CartV2/SummaryBox/SummaryInfoBox'
import SummaryBoxDesktop from './SummaryBox/Desktop'
import SummaryBoxMobile from './SummaryBox/Mobile'
import Deliveries from './Deliveries'

const Cart = () => {
  const isDesktop = useOfMinWidth(APP_BREAKPOINTS.DESKTOP_START)
  const userData = useSelector(userDataSelector)
  const { data: cartData, isLoading } = useGetCartQuery()

  const cartSummaryProps = {
    userData,
    cartData,
  }

  if (isLoading) return null

  return (
    <div className="w-full">
      <div className="flex flex-col gap-2.5 w-full px-3 py-5 justify-end lg:flex-row lg:gap-10 lg:px-8 lg:py-20">
        {!isDesktop && (
          <SummaryInfoBox
            userData={userData}
            cartData={cartData}
            isExpandable
          />
        )}
        <Deliveries />
        {isDesktop && <SummaryBoxDesktop {...cartSummaryProps} />}
      </div>
      {!isDesktop && <SummaryBoxMobile {...cartSummaryProps} />}
    </div>
  )
}

export default Cart
